import React from "react";

type ContactSectionProps = {
  mail: string;
  message: string;
  name: string;
  phoneNumber: string;
  subject: string;
  onMailChange: (value: string) => void;
  onMessageChange: (value: string) => void;
  onNameChange: (value: string) => void;
  onPhoneNumberChange: (value: string) => void;
  onSubjectChange: (value: string) => void;
  onSubmit: () => void;
};

const ContactSection: React.FC<ContactSectionProps> = ({
  mail,
  message,
  name,
  phoneNumber,
  subject,
  onMailChange,
  onMessageChange,
  onNameChange,
  onPhoneNumberChange,
  onSubjectChange,
  onSubmit,
}) => {
  return (
    <section className="mx-auto mt-24 max-w-7xl px-6 pb-24 lg:px-8" id="contact">
      <div className="rounded-[2rem] bg-gray-50 px-6 py-14 sm:px-10 lg:px-16">
        <div className="mx-auto max-w-5xl">
          <div className="mx-auto mb-10 max-w-md text-center">
            <span className="inline-block mb-4 text-sm font-bold uppercase tracking-widest text-indigo-600">
              Contact Us
            </span>
            <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              Get connected
            </h2>
            <p className="mt-6 text-gray-500">
              お問い合わせ、ご相談、プロジェクトのご依頼など、お気軽にお問い合わせください。
            </p>
          </div>
          <form
            className="rounded-[1.5rem] border border-gray-200 bg-white p-6 shadow-sm sm:p-8"
            onSubmit={(event) => {
              event.preventDefault();
              onSubmit();
            }}
          >
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
              <div>
                <label className="mb-2 block text-sm font-bold text-gray-500" htmlFor="contact-name">
                  お名前
                </label>
                <input
                  className="w-full rounded-xl border border-gray-200 bg-white px-5 py-3 text-base font-semibold text-gray-700 outline-none transition focus:ring-4 focus:ring-blue-100"
                  id="contact-name"
                  type="text"
                  value={name}
                  onChange={(event) => onNameChange(event.target.value)}
                />
              </div>
              <div>
                <label className="mb-2 block text-sm font-bold text-gray-500" htmlFor="contact-mail">
                  メールアドレス
                </label>
                <input
                  className="w-full rounded-xl border border-gray-200 bg-white px-5 py-3 text-base font-semibold text-gray-700 outline-none transition focus:ring-4 focus:ring-blue-100"
                  id="contact-mail"
                  type="email"
                  value={mail}
                  onChange={(event) => onMailChange(event.target.value)}
                />
              </div>
            </div>
            <div className="mt-5">
              <label className="mb-2 block text-sm font-bold text-gray-500" htmlFor="contact-phone">
                電話番号
              </label>
              <input
                className="w-full rounded-xl border border-gray-200 bg-white px-5 py-3 text-base font-semibold text-gray-700 outline-none transition focus:ring-4 focus:ring-blue-100"
                id="contact-phone"
                type="text"
                value={phoneNumber}
                onChange={(event) => onPhoneNumberChange(event.target.value)}
              />
            </div>
            <div className="mt-5">
              <label className="mb-2 block text-sm font-bold text-gray-500" htmlFor="contact-subject">
                件名
              </label>
              <input
                className="w-full rounded-xl border border-gray-200 bg-white px-5 py-3 text-base font-semibold text-gray-700 outline-none transition focus:ring-4 focus:ring-blue-100"
                id="contact-subject"
                type="text"
                value={subject}
                onChange={(event) => onSubjectChange(event.target.value)}
              />
            </div>
            <div className="mt-5">
              <label className="mb-2 block text-sm font-bold text-gray-500" htmlFor="contact-message">
                メッセージ
              </label>
              <textarea
                className="w-full rounded-2xl border border-gray-200 bg-white px-5 py-4 text-base font-semibold text-gray-700 outline-none transition focus:ring-4 focus:ring-blue-100"
                id="contact-message"
                rows={8}
                value={message}
                onChange={(event) => onMessageChange(event.target.value)}
              />
            </div>
            <div className="mt-6 flex justify-end">
              <button
                className="rounded-full bg-indigo-600 px-8 py-3 text-sm font-semibold text-white transition hover:bg-indigo-700 focus:ring-4 focus:ring-blue-100"
                type="submit"
              >
                送信する
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
